/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { ConcernsIssueDto } from './concernsIssueDto.schema';

export const ListOfConcernsIssueDto = zod.array(zod.lazy(() => ConcernsIssueDto));

export type ListOfConcernsIssueDto = zod.input<typeof ListOfConcernsIssueDto>;
export type ListOfConcernsIssueDtoOutput = zod.output<typeof ListOfConcernsIssueDto>;
